import React from "react";

import ErrorIcon from "@mui/icons-material/ErrorOutline";
import { Stack } from "@mui/material";

import Text from "@src/sharedComponents/Typography/Text";

interface Props {
  text: string;
  iconColor: "error" | "info";
}

const NoDataSet: React.FC<Props> = ({ text, iconColor }) => {
  return (
    <Stack
      direction="row"
      spacing={1}
      alignItems="center"
      style={{
        height: "200px",
        justifyContent: "center",
      }}
    >
      <ErrorIcon color={iconColor} fontSize="small" />

      <Text variant="body" color="textSubtle">
        {text}
      </Text>
    </Stack>
  );
};

export default NoDataSet;
